import { assign, each, flatMap, mapValues, reduce, sortBy, uniq } from 'lodash'

const pushOrCreateKey = (obj, value, name) => {
  const found = obj[name]

  if (found) {
    return found.push(value)
  }

  return assign(obj, { [name]: [value] })
}

const uniqSortedValues = values => {
  return sortBy(uniq(values))
}

const toObject = (attributes, attribute) => {
  const { name, value } = attribute

  return assign(attributes, { [name]: value })
}

export const getRefineAttributes = product => {
  if (!product?.attributes) return {}

  return reduce(product.attributes, toObject, {})
}

const reduceAttributes = (result, attribute) => {
  each(attribute, pushOrCreateKey.bind(null, result))

  return result
}

const groupVariantsAttributes = variants => {
  const attributes = flatMap(variants, 'refinedAttributes')

  const reduced = reduce(attributes, reduceAttributes, {})

  return mapValues(reduced, uniqSortedValues)
}

export const getVariantAttributes = (allVariants = [], fallbackProduct) => {
  const allProducts = [...allVariants, fallbackProduct]

  const productsWithRefined = allProducts.map(product => ({
    ...product,
    refinedAttributes: getRefineAttributes(product),
  }))

  return groupVariantsAttributes(productsWithRefined)
}

export default getVariantAttributes
